import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PowerMeetReportLayer from "../components/PowerDateReportLayer";

const PowerMeetReportPage = () => {
    return (
        <MasterLayout>
            <PowerMeetReportLayer />
        </MasterLayout>
    );
};

export default PowerMeetReportPage;
